module.exports = __webpack_public_path__ + "static/media/relojHeader.cff1dccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/relojHeader.svg
// module id = 1799
// module chunks = 0